const items = (that) => [
    {
        enabled: true,
        key: 0,
        label: that?.$t("message.liveSupport"),
        icon: {
            type: "material-icons",
            name: "support_agent",
        },
    },
    {
        enabled: true,
        key: 6,
        label: that?.$t("message.teamChat"),
        counter: that?.unreadMessages,
        icon: {
            type: "material-icons",
            name: "group",
        },
    },
    {
        enabled: true,
        key: 1,
        label: that?.$t("message.siteVisitors"),
        counter: that?.liveVisitorCount,
        icon: {
            type: "material-icons",
            name: "public",
        },
    },
    {
        enabled: true,
        key: 4,
        counter: that?.chatbotLive,
        label: that?.$t("ChatBOT"),
        icon: {
            type: "chatbot",
            name: "chatbot",
        },
    },
    {
        enabled: true,
        key: 2,
        label: that?.$t("message.conversationHistory"),
        icon: {
            type: "material-icons",
            name: "history",
        },
    },
    {
        enabled: true,
        key: 3,
        label: that?.$t("message.representative"),
        icon: {
            type: "material-icons",
            name: "engineering",
        },
    },
    {
        enabled: true,
        key: 5,
        label: that?.$t("WhatsappContacts"),
        icon: {
            type: "component",
            name: "WhatsappIcon",
        },
    },
    {
        enabled: true,
        key: 9,
        label: that?.$t("InstagramContacts"),
        icon: {
            type: "component",
            name: "InstagramIcon",
        },
    },
    {
        enabled: true,
        key: 10,
        label: that?.$t("MessengerContacts"),
        icon: {
            type: "component",
            name: "MessengerIcon",
        },
    },
    {
        enabled: true,
        key: 8,
        label: that?.$t("message.events"),
        icon: {
            type: "material-icons",
            name: "event",
        },
    },
    {
        enabled: true,
        key: 11,
        label: that?.$t("message.reservations"),
        icon: {
            type: "material-icons",
            name: "event_available",
        },
    },
    {
        enabled: true,
        key: 7,
        label: that?.$t("notification.activities"),
        icon: {
            type: "material-icons",
            name: "rss_feed",
        },
    },
];

export default items;
